import { IMeterAppointment } from "@/models/meterAppointment/meterAppointment.types"
import { QueryResult } from "@/api/utils/types"
import { useQuery } from "@/api/utils/useQuery"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import {
  IMeterAppointmentRaw,
  MeterAppointmentsParser,
} from "@/models/meterAppointment/meterAppointment.parser"

export interface IMeterAppointmentService {
  getAppointments(
    billingAccountId: number | null,
  ): QueryResult<IMeterAppointment[]>
}

class MeterAppointmentServiceClass implements IMeterAppointmentService {
  getAppointments(
    billingAccountId: number | null,
  ): QueryResult<IMeterAppointment[]> {
    return useQuery({
      ...BackofficeRestQueries.meterAppointment.getAppointment(
        billingAccountId ?? 0,
      ),
      enabled: !!billingAccountId,
      placeholderData: [],
      useRawResponse: true,
      parserFn: (rawData: IMeterAppointmentRaw[]) =>
        MeterAppointmentsParser.toDomain(rawData ?? []),
    })
  }
}

export const MeterAppointmentService = new MeterAppointmentServiceClass()
